import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "license-plate" };
const _hoisted_2 = { class: "license-plate__content" };
const _hoisted_3 = { class: "license-plate__text" };
import { computed } from 'vue';
import { useAssets } from '../../composables/useAssets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LicensePlateCard',
    props: {
        licencePlate: { default: '' },
        emptyText: { default: 'No Reg' },
        actionLabel: { default: 'Edit' }
    },
    emits: ["edit"],
    setup(__props) {
        const props = __props;
        const { assetUrl } = useAssets();
        const displayPlate = computed(() => (props.licencePlate !== '' ? props.licencePlate : props.emptyText));
        const editIconMaskStyle = computed(() => {
            const image = `url('${assetUrl('/images/trade-site/edit-pen.svg')}')`;
            return {
                maskImage: image,
                WebkitMaskImage: image,
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(displayPlate.value), 1),
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('edit'))),
                        class: "license-plate__edit",
                        type: "button"
                    }, [
                        _createElementVNode("span", {
                            class: "license-plate__edit-icon",
                            style: _normalizeStyle(editIconMaskStyle.value),
                            "aria-hidden": "true"
                        }, null, 4),
                        _createElementVNode("span", null, _toDisplayString(__props.actionLabel), 1)
                    ])
                ])
            ]));
        };
    }
});
